export class Loading {
  constructor() {
    const containerId = "loading-container";
    this.containerEl = document.getElementById(containerId);

    if (!this.containerEl) {
      this.containerEl = document.createElement("div");
      this.containerEl.id = containerId;
      document.body.appendChild(this.containerEl);
    }

    // Add spinner animation styles if not already added
    if (!document.getElementById('loading-animations')) {
      const style = document.createElement('style');
      style.id = 'loading-animations';
      style.innerHTML = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }
  }

  show(background = "rgba(255, 255, 255, 0.9)") {
    this._show({ background });
  }

  _show({ background = "rgba(255, 255, 255, 0.9)" }) {
    // Remove existing loading if any
    this.hide();

    const loadingEl = document.createElement("div");
    loadingEl.id = "loading_view";
    loadingEl.innerHTML = `
      <div style="
        display: flex;
        flex-direction: column;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9998;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        background: ${background};
        animation: fadeIn 0.2s ease-out;
      ">
        <div style="
          width: 48px;
          height: 48px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #00A809;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        "></div>
      </div>
    `;
    this.containerEl.appendChild(loadingEl);
  }

  hide() {
    const loadingEl = document.getElementById("loading_view");
    if (loadingEl) {
      // Add fade out animation before removing
      loadingEl.style.animation = 'fadeOut 0.2s ease-out';
      setTimeout(() => {
        loadingEl.remove();
      }, 200);
    }
  }
}

// 创建全局单例
let loadingInstance = null;

export const getLoading = () => {
  if (!loadingInstance) {
    loadingInstance = new Loading();
  }
  return loadingInstance;
};
